@import '../../content/Variables.scss';

.sticky-action-bar {
    align-items: center;
    background-color: $white;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 24rem;
    box-shadow: 0px -8px 5px -5px #bbb;
    z-index: 100;
    margin: 0;
    height: 7rem;
    border-right: 1px solid #DDDDDD;
    border-top: 1px solid $off-black;

    h3 {
        margin: 0;
    }

    &.maxed-out {
        right: auto;
        width: 1200px;
    }

    .popover-button-wrapper {
        width: 100%;
        position: relative;
    }

    button.btn-clear {
        display: block;
        width: 100%;
        border: 1px solid $near-white;
        box-shadow: 0px 1px 1px 0px $dark-grey;
        padding: 1rem;

        &:hover {
            background-color: $ice-blue;
        }
    }

        
    &.stopaction-add-orders {
        left: auto;
        width: 89.5rem;
        bottom: 7.5rem;
        height: 8rem;
    }

    &.flyout-large-drawer {
        left: auto;
        width: 75vw;
        bottom: 7.5rem;
        height: 6rem;
        border-left: 5px solid $black;
    }

    &.planning-running-totals .running-total-bar p.row-label {
        margin-bottom: 0;
        line-height: 4rem;
    }


    .running-total-bar {
        display: flex;
        justify-content: space-between;
        width: 100%;

        div {
            justify-content: flex-end;
        }

    
    }
    

    .action-bar-popover {
        background-color: $white;
        border: 1px solid $dark-grey;
        border-radius: .4rem .4rem 0 0;
        position: absolute;
        top: -19.1rem;
        right: 0rem;
        left: 0rem;
        height: 20rem;
        padding: 1.5rem;
        z-index: 1;
        transform-origin: left top;

        .action-bar-popover-list {
            overflow-y: scroll;
            height: 16rem;

            ul {
                padding: 0;        
                margin: 0;
                list-style-type: none;
                padding-bottom: 1rem;
        
                li {
                    border-bottom: 1px solid $grey;
                    display: inline-flex;
                    width: 100%;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 1.3rem;
                    height: 3rem;
                    padding-left: 1rem;
                    padding-right: 1rem;
                    padding-top: .5rem;
                
                    &:hover {
                        background-color: $bright-green;
                        color: $white;
                        cursor: pointer;
                    }
                }
            }
        }

    }

}

.showStickyActionBar-enter-active {
    -webkit-animation: fadeIn 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    animation: fadeIn 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.showStickyActionBar-exit-active {
    -webkit-animation: fadeOut 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    animation: fadeOut 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}


@media (max-width: 1000px) {
    .sticky-action-bar {
        left: 0;
    }
}
